import React from "react";

import PropTypes from "prop-types";

import Icon from "Common/Icon";

import type {
  MedicalPlan,
  DentalPlan,
  VisionPlan,
  AccidentPlan,
  LongTermDisabilityPlan,
  ShortTermDisabilityPlan,
  LifePlan,
  TermLifePlan,
  WholeLifePlan,
} from "Utils/types";

import makeBem from "Utils/makeBem";

const bem = makeBem("ComparePage");

type Props = {
  plan: MedicalPlan | DentalPlan | VisionPlan | LifePlan | TermLifePlan | WholeLifePlan | AccidentPlan | ShortTermDisabilityPlan | LongTermDisabilityPlan;
  copy?: string;
};

export default function SBCLinkCell({ plan, copy }: Props) {
  if (plan.has_sbc) {
    return (
      <a href={plan.sbc_url} target="_blank" className={bem("Link")} rel="noreferrer">
        <Icon icon="download" flavor="solid" />
        {copy ? ` ${copy}` : " Summary of Benefits"}
      </a>
    );
  }
  const body = `Hello SimplyInsured,\n\nPlease send me a copy of the Summary of Benefits and Coverage for the ${plan.carrier} ${plan.display_name} Plan.\n\nThank you!\n\n\nPlan ID: ${plan.id}\nPlan Name: ${plan.raw_name}`;
  const mailto_url = `mailto:hello+sbc@simplyinsured.com?subject=SBC Request&body=${encodeURIComponent(body)}`;
  return (
    <a href={mailto_url}>
      <Icon icon="envelope" mr={3} />
      Request
    </a>
  );
}

SBCLinkCell.propTypes = {
  plan: PropTypes.object.isRequired,
};
